
import React, { useEffect, useState } from 'react';
import "./Schedule.css";
import { useGlobalContext } from "../../context";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { Dropdown } from "primereact/dropdown";
import EditScheduleTable from "./EditScheduleTable";
import { sendPostFiles, sendSchedulePost } from "../../api";

function EditSchedule() {

    const {
        categorys,
        setCategorys,
        setOpenCompleted,
        scheduleCategory,
        activeCategory,
        setActiveCategory
    } = useGlobalContext()

    const [caption, setCaption] = useState();
    const [files,setFiles] = useState([]);
    const [checkinClients, setCheckinClients] = useState([]);
    const [dateTime, setDateTimeValue] = useState();
    const [fileLinks, setFileLinks] = useState([]);
    const [fileError, setFileError] = useState(false);
    const [postStarted, setPostStarted] = useState(false);
    const [scheduleCategoryType, setScheduleCategoryType] = useState();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setCaption(location.state.caption)
        setScheduleCategoryType(scheduleCategory.find(item => item.text.toUpperCase() === location.state.scheduleType));
        setFileLinks(location.state.attachments);
        if (location.state.category) {
            setCategorys(categorys => categorys.map(ctgry => ctgry.text === location.state.category.replaceAll("_", " ").toUpperCase() ? { ...ctgry, active: true } : { ...ctgry, active: false }));
        }
    }, []);

    useEffect(() => {
        const active = categorys.find(item => item.active === true);
        if (active) {
            setActiveCategory(active.text);
        }
    }, [categorys])

    const filesHandler = e => {
        if (e.target.files.length === 1 && e.target.files[0].type.includes("image")) {
            if (e.target.files[0].size < 4 * 1048576) {
                setFiles(files => {
                    return  [e.target.files[0]];
                });
                setFileError(false);
            }
            else {
                setFileError(true);
            }
        }

        else if (e.target.files.length === 1 && e.target.files[0].type.includes("video")) {
            setFiles(files => { return [e.target.files[0]] });
            setFileError(false);
        }

        else {
            for (let i = 0; i < e.target.files.length; i++) {
                if (e.target.files[i].size < 4 * 1048576) {
                    setFiles(files => { return [ ...files, e.target.files[i] ] });
                    setFileError(false);
                }
                else {
                    setFileError(true);
                }
            }
        }
    }

    const changeActiveCategory = (item) => {
        setCategorys(categorys => categorys.map(ctgry => ctgry.id === item.id ? { ...ctgry, active: true } : { ...ctgry, active: false }));
    }

    const deleteFile = (e) => {
        setFiles(files => files.filter(item => item.name !== e.name));
    }

    const submitFetchData = async (list) => {
        let form = {};
        if (list.length > 1) {
            form.postingType = "MULTIPLE_IMAGE";
        }
        else if (list.length === 1) {
            const format = list[0].split('.')?.pop();
            if (format === "jpg" || format === "jpeg" || format === "png") {
                form.postingType = "SINGLE_IMAGE";
            }
            else if (format === "mp4" || format === "avi") {
                form.postingType = "VIDEO";
            }
        }
        form.id = location.state.scheduleId;
        form.caption = caption;
        form.attachments = list;
        form.clients = checkinClients
        if (dateTime) {
            form.scheduleDate = dateTime;
        }
        else {
            form.scheduleDate = location.state.scheduleDate;
        }

        form.scheduleType = scheduleCategoryType?.text.toUpperCase();
        form.category = scheduleCategoryType?.text.toUpperCase() === "CATEGORY" ? activeCategory.replaceAll(" ", "_") : null;

        const sendData = await sendSchedulePost(JSON.stringify(form));
        if (sendData) {
            setFileLinks([]);
            setFiles([]);
            setCaption("");
            setPostStarted(false);
            setOpenCompleted(true);
            navigate("/schedule")
        }
        setPostStarted(false);
    }

    const submitPost = async (e) => {
        setPostStarted(true);
        if (files.length > 0) {
            let formData = new FormData();
            files.forEach((item, index) => {
                formData.append(`images[${index}]`, item);
            })

            try{
                const response = await sendPostFiles(formData);
                setFileLinks(response.data)
            }
            catch(err) {
                console.log(err);
            }
        }
        else {
            submitFetchData(fileLinks);
        }
    }

    useEffect(() => {
        if (fileLinks.length > 0 && fileLinks.length === files.length) {
            submitFetchData(fileLinks);
        }
    },[fileLinks])

    const changeTime = (dateTime) => {
        return new Date(dateTime).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
        })
    }

    return(
        <div className = "addPost">
            <div className = "addPostMainBox">
                <div className = "usersTableHeaderBox">
                    <h3
                        className = "usersTableHeaderText"
                        style = {{
                            marginLeft: "20px"
                        }}
                    >
                        SCHEDULE POST EDIT
                    </h3>
                </div>
                <div className = "addPostCheckTextareaBox">
                    <span className = "addPostTextareaText">Caption</span>
                    <span className = "addPostTextareaAndFileAddBox">
                        <textarea
                            className="addPostTextareaInput"
                            value = { caption }
                            onChange = { e => setCaption(e.target.value) }
                        >
                        </textarea>
                        <span className="addPostAddFileSpan">
                            {
                                files.length > 0 ?
                                    files.map(item =>
                                        <span
                                            className="addPostFileName"
                                            style = {{
                                                margin: "0 10px",
                                                color: "rgba(0,0,0,0.6)"
                                            }}
                                        >
                                            { item.name }
                                            <CloseIcon
                                                style = {{
                                                    fontSize: "18px",
                                                    cursor: "pointer",
                                                    margin: "0 5px"
                                                }}
                                                onClick = { deleteFile.bind(this, item) }
                                            />
                                        </span>
                                    )
                                    :
                                    fileLinks.map(link => {
                                        return <span
                                                    className="addPostFileName"
                                                    style = {{
                                                        margin: "0 10px",
                                                        color: "rgba(0,0,0,0.6)"
                                                    }}
                                                >
                                                    { link }
                                                </span>
                                    })
                            }
                            <AttachFileIcon
                                style = {{
                                    transform: "rotate(45deg)",
                                    color: "#666666",
                                    margin: "0 10px"
                                }}
                            />
                            <input
                                type = "file"
                                className = "addFileInput"
                                onChange = { filesHandler }
                                multiple = { true }
                                accept = ".jpg, .jpeg, .png, .mp4, .avi"
                            />
                        </span>
                    </span>
                </div>
                {
                    fileError ?
                        <p className="fileErrorText">
                            File size must not exceed 4MB
                        </p>
                        : null
                }
                <div
                    className="postBtnBox"
                    style={{
                        justifyContent: "space-between"
                    }}
                >
                    <div className="schedulePostDateTimeCategoryBox">
                        <DateTimePicker
                            label = { changeTime(location.state.scheduleDate) }
                            className = "dateTimePicker"
                            value = { dateTime }
                            onChange = { e => setDateTimeValue(e) }
                        />
                        <Dropdown
                            options = { scheduleCategory }
                            optionLabel = "text"
                            placeholder = "Select By"
                            className = "schedulePostDropdown"
                            value = { scheduleCategoryType }
                            onChange = { e => setScheduleCategoryType(e.value) }
                        />
                    </div>
                    <button
                        className = "postSubmitBtn"
                        style = {{
                            backgroundColor: "#3F68B1",
                            color: "white",
                        }}
                        onClick = { submitPost }
                    >
                        SCHEDULE
                    </button>
                </div>
                <div className="addPostCategoryFilter">
                    {
                        categorys.map(item => item.id !==0 &&
                            <span
                                key = { item.id }
                                className = "addPostCategorySpan"
                                style = {{
                                    backgroundColor: item.active ? "#3F68B1" : "#FAFAFA",
                                    color: item.active ? "white" : "#929292",
                                    border: item.active ? "none" : "1px solid #929292"
                                }}
                                onClick = { changeActiveCategory.bind(this, item) }
                            >
                                { item.text }
                            </span>
                        )
                    }
                </div>
                <EditScheduleTable
                    activeCategory = { activeCategory }
                    checkinClients = { checkinClients }
                    setCheckinClients = { setCheckinClients }
                    scheduleCategoryType = { scheduleCategoryType }
                />
            </div>
        </div>
    )
}

export default EditSchedule